import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import Quasar from 'quasar/src/vue-plugin.js';import Lang from 'quasar/src/plugins/lang/Lang.js';;
import langRu from "quasar/lang/ru";
import quasarUserOptions from "./quasar-user-options";

Lang.set(langRu);
import { vue3Debounce } from "vue-debounce";
import money from "v-money3";
import "@/assets/styles/global.scss";
import "quasar/dist/quasar.sass";
import "@/assets/tailwind.css";
import VueKonva from "vue-konva";
import { QueryClient, VueQueryPlugin } from "@tanstack/vue-query";
import { createPinia } from "pinia";
import { TourGuideManager, TourGuideTooltip } from "v-tour-guide";
import "v-tour-guide/style.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const pinia = createPinia();

createApp(App)
  .use(Quasar, quasarUserOptions)
  .use(VueKonva)
  .use(pinia)
  .use(router)
  .use(money)
  .use(VueQueryPlugin, { queryClient })
  .directive("debounce", vue3Debounce({ lock: true }))
  .component("TourGuideManager", TourGuideManager)
  .component("TourGuideTooltip", TourGuideTooltip)
  .mount("#app");
